import { render } from "./exchange.vue?vue&type=template&id=ac58ffe4"
import script from "./exchange.vue?vue&type=script&lang=js"
export * from "./exchange.vue?vue&type=script&lang=js"

import "@/styles/striNew.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__